import React, { FC, useCallback } from "react";
import { FlowLayout } from "kw/components/FlowLayout";
import { navigate, RouteComponentProps } from "@reach/router";
import { PasswordLessUserRegisterForm } from "kw/components/RegisterForm/PasswordLessUserRegisterForm";

type TPasswordLessUserRegisterPage = {
  riskProfileId: string;
};
export const PasswordLessUserRegisterPage: FC<
  TPasswordLessUserRegisterPage & RouteComponentProps
> = ({ riskProfileId, location }) => {
  const [isPreviousFlowEmpty] = React.useState(location?.state?.isPreviousFlowEmpty);
  const onRegistrationComplete = useCallback(() => {
    navigate(`/quoting/payment/${riskProfileId}/`);
  }, []);

  const getBackLocation = useCallback((isPreviousFlowEmpty, localHistory) => {
    if (
      !isPreviousFlowEmpty &&
      Array.isArray(localHistory) &&
      localHistory.length > 1
    ) {
      // The current passwordless page is the last item in history.
      const previousQuestionSetKey = localHistory[localHistory.length - 2]?.key;
      if (previousQuestionSetKey) {
        return `/quoting/policyholders/${riskProfileId}/${previousQuestionSetKey}`;
      }
    }
    return "/quote/ready";
  }, []);
  const backLocation = getBackLocation(isPreviousFlowEmpty, location?.state?.history);

  return (
    <FlowLayout
      defaultBackLocation={backLocation}
      steps={[
        {
          label: "Your details",
          complete: true,
        },
        { label: "Your quote", complete: true },
        {
          label: "Review and buy",
          active: true,
          current: 2,
          total: 3,
        },
      ]}
      history={[]}
    >
      <PasswordLessUserRegisterForm
        onRegistrationComplete={onRegistrationComplete}
        submitButtonText="Next"
      />
    </FlowLayout>
  );
};
